// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"61cd6676","453":"ac9b7e2a","455":"ff6df498","977":"405355fc"}[chunkId] + ".chunk.js";
};